import base from './Base';

var Nav = (function () {
    'use strict';
    
    /* Variable inits */
    const overlayContainerEl = base.get('#overlay-container');
    const openMenuEl = base.get('#navbarToggler');
    const dropDownMenu = document.querySelectorAll('.xs-menu .dropdown-toggle');

    /* Handles opening mobile menu */
    const openMobileMenu = () => {
        overlayContainerEl.classList.add("overlay");
        openMenuEl.classList.remove('hideMenu');
        openMenuEl.classList.add('showMenu');
    }

    /* Handles Closing mobile menu */
    const closeMobileMenu = () => {
        overlayContainerEl.classList.remove("overlay");
        openMenuEl.classList.add('hideMenu');
        openMenuEl.classList.remove('showMenu');
    }

    /* Handles Click Event to toggle mobile menu */
    const getMenuShowHide = (e) => {
        const elem = e.target;
        const toggleMenu = elem.getAttribute('data-mobileMenu');
        if (!toggleMenu) { return false; }

        e.preventDefault();

        switch (toggleMenu) {
            case 'show':
                openMobileMenu();
                break;
            case 'hide':
                closeMobileMenu();
                break;
        }
    };

    const handleEvents = () => {
        window.addEventListener('click', (e) => { getMenuShowHide(e); });

        //add back to top button on scroll
        window.addEventListener('scroll', function () {
            const scrollToTop = document.getElementById("scrollToTop");
            if (window.scrollY > 5) {
                scrollToTop.classList.remove("hidden");
                scrollToTop.classList.add("active");
            } else {
                scrollToTop.classList.remove("active");
                scrollToTop.classList.add("hidden");
            }
        })

        dropDownMenu.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const sub = e.target.nextElementSibling;
                if (sub.classList.contains("show")) {
                    sub.classList.remove("show");
                } else {
                    sub.classList.add("show");
                }
                
            })
        })

      
    };


    function init() {
        handleEvents();    
    }

    return {
        init: init
    };
}());

export default Nav;
